import { render } from "./PanelTipsterResumen.vue?vue&type=template&id=6481602c&scoped=true"
import script from "./PanelTipsterResumen.vue?vue&type=script&lang=js"
export * from "./PanelTipsterResumen.vue?vue&type=script&lang=js"

import "./PanelTipsterResumen.vue?vue&type=style&index=0&id=6481602c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6481602c"]])

export default __exports__